import React, { Component } from 'react'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import {
	createOrReturnChat,
	logoutUser,
	openHeaderTab,
	getUserData,
	openModal,
} from 'state/actions'

import { getCurrentUser } from 'state/selectors'
import { API_URL } from 'state/api'
import { isEqual, forIn } from 'lodash'
import copy from 'fast-copy'

import {
	TYPING_SET,
} from 'state/actions/types'

import {
	doToken,
	isMobile,
	stripHtml
} from 'utils'

import { isCordova } from 'env.js'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Notification from 'react-web-notification'

class Socket extends Component {
	state = {
		onlineUsers: [],
		token: null,
		desktopNotification: null
	}

	UNSAFE_componentWillMount() {
		doToken('get', null, response => {
			const {
				token
			} = response

			if (token) {
				window.Echo = new Echo({
					broadcaster: 'pusher',
					key: '4b6b5bbf340015aab874',
					authEndpoint: API_URL + '/broadcasting/auth',
					cluster: 'ap1',
					encrypted: true,
					auth: {
						headers: {
							Authorization: 'Bearer ' + token,
						},
					},
				})

				this.attachListeners()
			} else {
				this.props.logoutUser()
			}
		})

		if (window.FirebasePlugin && isCordova) {
			window.FirebasePlugin.onNotificationOpen(notification => {
				this.props.getUserData(this.props.userData.id)

				switch (notification.type) {
					case 'notification':
						this.handleReceiveNotification(notification.notification)

						if (notification.tap) {
							this.props.openHeaderTab('notifications')
						}
						break
					case 'chat':
						this.handleReceiveChatItem(notification.chatItem, notification.tap)
						break
					case 'invitation':
						this.handleReceiveInvitation(notification.invitation)
						break
				}
			}, function (error) {
				console.error(error)
			})
		}

		window.addEventListener("focus", this.handleFocus)
	}

	componentWillUnmount() {
		window.removeEventListener("focus", this.handleFocus)

		this.disconnectAll()
	}

	disconnectAll = _ => {
		if (window.Echo && window.Echo.connector && window.Echo.connector.channels) {
			Object.keys(window.Echo.connector.channels).forEach(channel => {
				window.Echo.leave(channel)
			})
		}
	}

	handleFocus = _ => {
		this.attachListeners()
	}

	UNSAFE_componentWillUpdate = nextProps => {
		// this is super chill, it's just arrays of IDs
		if (!isEqual(this.props.userData.accounts, nextProps.userData.accounts)) {
			// check every update if we need to re-connect
			this.disconnectAll()
			this.attachListeners()
		}
	}

	handleReceiveNotification = (tempNotification, meta = null) => {
		const dispatch = this.props.dispatch

		const notification = typeof (tempNotification) == 'string' ? JSON.parse(tempNotification) : tempNotification


		if (notification) {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: notification,
				entityType: 'notification',
			})
		}

		if (!isMobile() && meta) {
			this.doDesktopNotification(meta.subject, meta.entityTitle)
		}
	}

	handleReceiveChatItem = (tempChatItem, openChat) => {
		const {
			dispatch,
			userData,
			chatFocusData,
			activeChats,
			createOrReturnChat,
			entities
		} = this.props

		const chatItem = typeof tempChatItem == 'string' ? JSON.parse(tempChatItem) : tempChatItem

		let message = chatItem.object

		var chat = {
			id: message.chat_id
		}

		// we're reconstituting 'latestVersion' here cause it was too big for the sockets.
		if (chatItem.object && chatItem.object.file) {
			const version = copy(chatItem.object)
			delete version.file

			chatItem.object.file.latestVersion = version
		}

		if (!userData || !userData.chats) {
			return
		}

		if (userData.chats.find(chatId => {
			return chatId === message.chat_id
		})) {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: chatItem,
				entityType: 'chatItem',
			})

			if (message.sender_id == userData.id) {
				if (chatFocusData) {
					forIn(chatFocusData, (chatId, userId) => {
						if (chatId == message.chat_id) {
							if (message.seen_by) {
								message.seen_by.push(parseInt(userId))
							} else {
								message.seen_by = [parseInt(userId)]
							}
						}
					})
				}
			} else if (!isMobile()) {
				// not from me - do a notification
				const sender = message.sender_id ? entities.users[message.sender_id] : entities.users[message.user_id]

				const isFileFromMe = (message.user_id && message.user_id == userData.id)

				if (sender && message && !isFileFromMe) {
					const title = message.message_text ? `${sender.first_name} sent you a message` : `${sender.first_name} sent you a file`
					const body = message.message_text ? stripHtml(message.message_text) : message.filename

					this.doDesktopNotification(title, body)
				}
			}
		}

		let keepChatShut = true

		activeChats.forEach(activeChat => {
			if (activeChat.id === chat.id) {
				if (activeChat.isOpen) {
					keepChatShut = false
				}
			}
		})

		if (!isMobile() || openChat) {
			createOrReturnChat(chat, userData, null, keepChatShut)
		}
	}

	handleReceiveInvitation = invitation => {
		this.props.openModal('accept', 'pending_invitation', { invitation })
	}

	isChannelOpen = slug => {
		if (window.Echo && window.Echo.connector && window.Echo.connector.channels) {
			return window.Echo.connector.channels[slug]
		}

	}

	attachListeners() {
		// we can't destructure entities here cause they'll be different in the callback
		const {
			dispatch,
			userData,
		} = this.props

		if (!userData.accounts) {
			return
		}

		userData.accounts.forEach((accountId, index) => {
			if (this.isChannelOpen('presence-account_' + accountId)) {
				return
			}

			window.Echo.join('account_' + accountId)
				.here(onlineUsers => {
					dispatch({
						type: 'online_users_changed',
						payload: onlineUsers,
						event: 'init',
						isFirst: !index
					})
				})
				.joining(user => {
					dispatch({
						type: 'online_users_changed',
						payload: user,
						event: 'join'
					})
				})
				.leaving(leavingUser => {
					dispatch({
						type: 'online_users_changed',
						payload: leavingUser,
						event: 'leave'
					})
				})
				.listen('ChatItemSent', e => {
					if (e.userIds.find(userId => {
						return userId === this.props.userData.id
					})) {
						this.handleReceiveChatItem(e.chatItem)
					}
				}).listen('ActivityRegistered', e => {
					let entity = e.activity.activityable

					let isDeleted

					switch (e.activity.action) {
						case 'DELETE':
							isDeleted = true

							const entityCollection = this.props.entities[e.type + 's']

							if (entityCollection) {
								const deletedItem = this.props.entities[e.type + 's'][e.activity.activityable_id]

								if (deletedItem && !e.activity.activityable) {
									entity = deletedItem
								}
							}
							break
					}

					// we get merge issues when normalising activityItems in initData - mainly projects. 
					e.activity.fromSocket = true

					if (isDeleted) {
						if (entity) {
							entity.account_id = e.activity.account_id

							dispatch({
								type: 'ENTITY_DELETED',
								payload: entity,
								entityType: e.type,
							})
						}
					} else {
						dispatch({
							type: 'ENTITY_ADDED_OR_UPDATED',
							payload: e.activity,
							entityType: 'activity',
							overwriteUsers: e.activity.action == 'CHANGE_USERS',
							overwriteTasks: (e.activity.action == "UPDATE_ORDER" && e.type == 'milestone')
						})

						if (e.activity.action == 'NEW_GUEST') {
							dispatch({
								type: 'ADDED_GUEST',
								payload: entity
							})
						}

						// if a file is uploaded to a chat, we need to open the chat too.
						if (e.type === 'file') {
							const latestVersion = entity.latestVersion

							if (latestVersion && latestVersion.chat_id) {
								const chat = this.props.entities.chats[latestVersion.chat_id]

								let keepChatShut = false

								this.props.activeChats.forEach(activeChat => {
									if (activeChat.id === chat.id) {
										if (!activeChat.isOpen) {
											keepChatShut = true
										}
									}
								})

								// the file might be for zomeone else (and a project)
								if (chat && chat.userIds && chat.userIds.indexOf(this.props.userData.id) !== -1 && !isMobile()) {
									this.props.createOrReturnChat({
										id: latestVersion.chat_id
									}, null, null, keepChatShut)
								}
							}
						}
					}
				}).listen('UserUpdated', e => {
					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: e.user,
						entityType: 'user',
					})

				}).listenForWhisper('typing', e => {
					const { typingUserData } = this.props

					let isRedundant = false

					if (typingUserData) {
						if (typingUserData[e.userId] && typingUserData[e.userId].isTyping == e.isTyping && typingUserData[e.userId].chatId == e.chatId) {
							isRedundant = true
						}
					}

					if (!isRedundant) {
						dispatch({
							type: TYPING_SET,
							payload: e,
						})
					}
				}).listenForWhisper('focused', e => {
					const {
						entities,
						chatFocusData
					} = this.props

					if (!entities.chats) {
						return
					}

					const {
						messages,
						versions = {},
						chat_items
					} = entities

					let chat = entities.chats[e.chatId]

					if (chat && chat.chat_items && chat.chat_items.length) {
						const lastChatItem = chat_items[chat.chat_items[(chat.chat_items.length - 1)]]

						if (!lastChatItem || !lastChatItem.object) {
							return
						}

						let lastObject = lastChatItem.item_type == 'App\\Message' ? messages[lastChatItem.object.id] : versions[lastChatItem.object.id]

						if (lastObject) {
							let hasAlreadyRead = false

							lastObject = copy(lastObject)

							if (lastObject.seen_by) {
								if (lastObject.seen_by.find(id => {
									return id == e.userId
								})) {
									hasAlreadyRead = true
								}
							}

							if (!hasAlreadyRead) {
								if (lastObject.seen_by) {
									lastObject.seen_by.push(e.userId)
								} else {
									lastObject.seen_by = [e.userId]
								}

								// Circular JSON reference!!!

								dispatch({
									type: 'ENTITY_ADDED_OR_UPDATED',
									payload: lastObject,
									entityType: 'message',
								})
							}
						}
					}

					let isRedundant = false

					if (chatFocusData) {
						if (typeof chatFocusData[e.userId] !== 'undefined' && e.chatId == chatFocusData[e.userId]) {
							isRedundant = true
						}
					}

					if (!isRedundant) {
						dispatch({
							type: 'FOCUS_SET',
							payload: e
						})
					}
				})
		})

		if (this.isChannelOpen('presence-user_' + this.props.userData.id)) {
			return
		}

		window.Echo.join('user_' + this.props.userData.id)
			.listen('NotificationSent', e => {
				this.handleReceiveNotification(e.notification, e.meta)
			})
			.listen('UserInvited', e => {
				this.props.openModal('accept', 'pending_invitation', { invitation: e.invitation })
			})
			.listenForWhisper('activated', e => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: e.user,
					entityType: 'user',
				})
			})
			.listenForWhisper('setBigChatOpenStatus', e => {
				const { isOpen } = e

				dispatch({
					type: 'SET_BIG_CHAT_OPEN',
					payload: isOpen
				})
			})
	}

	doDesktopNotification = (title, body) => {
		if (document && !document.hasFocus()) {
			const desktopNotification = {
				title: title,
				options: {
					tag: Date.now(),
					body: body,
					icon: "https://app.hassl.co/images/hassl-notification.jpg",
					lang: 'en',
					dir: 'ltr',
				}
			}

			this.setState({
				desktopNotification
			})
		}

		const soundObject = document.getElementById('notification-sound')

		if (soundObject) {
			try {
				soundObject.play()
			} catch (e) {
				// doesn't matter
			}
		}
	}

	openDesktopNotification = _ => {
		this.setState({
			desktopNotification: null
		})
	}

	render() {
		const {
			desktopNotification
		} = this.state

		let className = 'socket-container'

		if (isMobile()) {
			return (
				<div className={className}></div>
			)
		}

		return (
			<div className={className}>
				<Notification
					onClick={this.openDesktopNotification}
					title={desktopNotification ? desktopNotification.title : ''}
					options={desktopNotification ? desktopNotification.options : null}
					timeout={10000}
				/>
				<audio id='notification-sound' preload='auto' volume={0.8}>
					<source
						src={document.base + '/sounds/notification.mp3'}
						type='audio/mpeg'
					/>
					<embed
						hidden={true}
						autostart={'false'}
						loop={false}
						src={document.base + '/sounds/notification.mp3'}
					/>
				</audio>
			</div>
		)
	}
}


const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		activeChats: state.auth.activeChats,
		chatFocusData: state.auth.chatFocusData,
		entities: state.account.entities,
		typingUserData: state.account.typingUserData,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch,
		createOrReturnChat: bindActionCreators(createOrReturnChat, dispatch),
		logoutUser: bindActionCreators(logoutUser, dispatch),
		openHeaderTab: bindActionCreators(openHeaderTab, dispatch),
		getUserData: bindActionCreators(getUserData, dispatch),
		openModal: bindActionCreators(openModal, dispatch),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Socket)